// Helper to trigger authenticated PDF/Excel download honoring Content-Disposition filename.
import { API_BASE } from "./api";

function pickFilename(disposition, fallbackPath) {
    if (disposition) {
        // RFC 5987 first
        const star = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
        if (star) return decodeURIComponent(star[1].replace(/^"|"$/g, ""));
        const plain = /filename="?([^";]+)"?/i.exec(disposition);
        if (plain) return plain[1];
    }
    return (fallbackPath.split("/").pop() || "download").split("?")[0];
}

export function openAuthDownload(path) {
    const token = localStorage.getItem("wmf_token");
    const url = `${API_BASE}${path}`;
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then(async (res) => {
            if (!res.ok) throw new Error("Download failed");
            const filename = pickFilename(res.headers.get("content-disposition"), path);
            const blob = await res.blob();
            return { blob, filename };
        })
        .then(({ blob, filename }) => {
            const objUrl = URL.createObjectURL(blob);
            // For PDFs, try to open in new tab; for everything else (xlsx etc) just download
            const isPdf = blob.type === "application/pdf" || filename.endsWith(".pdf");
            if (isPdf) {
                const w = window.open(objUrl, "_blank");
                if (!w) {
                    // Fallback to download with proper filename
                    const a = document.createElement("a");
                    a.href = objUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
            } else {
                const a = document.createElement("a");
                a.href = objUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
            }
            setTimeout(() => URL.revokeObjectURL(objUrl), 60_000);
        })
        .catch(console.error);
}
